/**
 * Feature 3 — In-app disclaimer shown when the publish gate has not been
 * met.  Visible to non-admin users (vendors, clients) whose dashboards
 * display a vendor score backed by thin data.  Wording locked to spec §261.
 */
export default function MaturityDisclaimer({ when }: { when: boolean }) {
  if (!when) return null;
  return (
    <div
      className="mb-4 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-700"
      role="note"
    >
      <span className="font-medium text-slate-800">Building reporting history.</span>{' '}
      Your account is still building reporting history on GuardGrade. Scores shown
      reflect available data and may fluctuate as more DARs are submitted and
      operational context is established. Confidence and trust labels indicate
      current data quality and will strengthen as the account matures.
    </div>
  );
}
